import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AlertIcon } from '@/shared/assets/icons/alert-icon';
import { Button } from '@/shared/components/ui/button/button';
import { IconContainer } from '@/shared/components/ui/icon-container/icon-container.styled';
import {
  Modal,
  ModalContainer,
} from '@/shared/components/ui/modal-controller/modal-controller.styled';
import { LanguageSwitcher } from '@/shared/features/language-switcher/language-switcher';
import { ThemeSwitcher } from '@/shared/features/theme-switcher/components/theme-switcher';
import { logout } from '@/shared/redux/api/auth/auth-api';
import { useReadTenantQuery } from '@/shared/redux/api/ident/ident-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const InactiveTenantWarning = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { data } = useReadTenantQuery();

  const isActive = data?.readTenant?.isActive;

  const handleLogout = async () => {
    await dispatch(logout());
    navigate(0);
  };

  if (!data || isActive) {
    return null;
  }

  return (
    <>
      <Stack
        direction="row"
        gap="1rem"
        position="fixed"
        top="1rem"
        right="1rem"
        zIndex={1400}
      >
        <ThemeSwitcher />
        <LanguageSwitcher />
      </Stack>
      <Modal open={true} disableEscapeKeyDown>
        <ModalContainer width="28rem">
          <Stack gap="2rem">
            <Stack gap="1.25rem" alignItems="center">
              <IconContainer>
                <AlertIcon />
              </IconContainer>
              <Typography variant="h5" textAlign="center">
                {t('common:inactive_tenant_warning_title')}
              </Typography>
              <Typography variant="p5" textAlign="center" color="textSecondary">
                {t('common:inactive_tenant_warning_description')}
              </Typography>
            </Stack>
            <Button
              variant="secondary"
              fullWidth
              size="large"
              onClick={handleLogout}
            >
              {t('ui:logout')}
            </Button>
          </Stack>
        </ModalContainer>
      </Modal>
    </>
  );
};
